import { Base, withIntersectionObserver } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin.js';

gsap.registerPlugin(DrawSVGPlugin);

/**
 *  Logo class.
 */
export default class Logo extends withIntersectionObserver(Base, {
  threshold: 0.8,
}) {
  static config = {
    name: 'Logo',
    refs: ['text', 'years[]'],
  };

  /**
   * @param {IntersectionObserverEntry[]} entries
   */
  intersected(entries) {
    if (entries[0].isIntersecting) {
      this.launchAnimation();
    }
  }

  /**
   * Launch the logo animation
   */
  launchAnimation() {
    const tl = gsap.timeline({
      onStart: () => {
        this.$terminate();
      },
    });

    tl.set(this.$el, { opacity: 1 });

    tl.fromTo(
      this.$refs.text.children,
      {
        opacity: 0,
        y: 20,
      },
      {
        y: 0,
        opacity: 1,
        duration: 1.4,
        ease: 'power4.out',
        stagger: {
          each: 0.05,
        },
      },
    );

    tl.fromTo(
      this.$refs.years,
      {
        drawSVG: 0,
      },
      {
        duration: 0.4,
        stagger: {
          amount: 0.8,
        },
        ease: 'power4.out',
        drawSVG: '100%',
      },
      '<=+0.4',
    );
  }
}
